import { createTheme } from "@mui/material/styles";
import {
  blue,
  deepOrange,
  deepPurple,
  green,
  lightBlue,
  orange,
  purple,
  teal,
} from "@mui/material/colors";

export const SITE_STYLE_IDS = ["default", "blue", "green", "purple", "dark"];

export const DEFAULT_SITE_STYLE = "default";

export const SITE_STYLE_PALETTES = {
  default: { primary: orange, secondary: deepOrange, mode: "light" },
  blue: { primary: lightBlue, secondary: blue, mode: "light" },
  green: { primary: teal, secondary: green, mode: "light" },
  purple: { primary: deepPurple, secondary: purple, mode: "light" },
  dark: { primary: orange, secondary: deepOrange, mode: "dark" },
};

export const isValidSiteStyle = (style) => SITE_STYLE_IDS.includes(style);

export const createAppTheme = (direction, siteStyle = DEFAULT_SITE_STYLE) => {
  const styleKey = isValidSiteStyle(siteStyle) ? siteStyle : DEFAULT_SITE_STYLE;
  const paletteConfig = SITE_STYLE_PALETTES[styleKey];

  return createTheme({
    direction,
    palette: {
      mode: paletteConfig.mode,
      primary: paletteConfig.primary,
      secondary: paletteConfig.secondary,
    },
    typography: {
      fontFamily: ["Tajawal", "Arial", "sans-serif"].join(","),
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
          },
        },
      },
    },
  });
};

export const SITE_STYLE_SWATCHES = {
  default: { primary: orange[500], secondary: deepOrange[500] },
  blue: { primary: lightBlue[500], secondary: blue[500] },
  green: { primary: teal[500], secondary: green[500] },
  purple: { primary: deepPurple[500], secondary: purple[500] },
  dark: { primary: "#424242", secondary: "#212121" },
};
